import { faker } from "@faker-js/faker";
import type { Meta, StoryObj } from "@storybook/react";

import type { SelectableCardProps } from "@/ui/core/SelectableCard";
import SelectableCard from "@/ui/core/SelectableCard";

const label = faker.lorem.words();
const StoryMeta: Meta<SelectableCardProps> = {
  title: "Core/Selectable Card",
  component: SelectableCard,
  argTypes: {
    accessibilityLabel: { control: "text" },
    isSelected: { control: "boolean" },
    label: { control: "text" },
    onSelect: { action: "Selected" },
    testID: { control: "text" },
  },
  args: {
    accessibilityLabel: label,
    label,
    testID: label,
  },
};

type Story = StoryObj<SelectableCardProps>;

const Primary: Story = {};

const Selected: Story = {
  args: {
    isSelected: true,
  },
};

export { Primary, Selected };
export default StoryMeta;
